/**
 * Utilities
 * @description Useful methods for global use
 */

/* global process */
 
/**
 * Debug - console.log wrapper
 *
 * @param mixed obj
 */
const debug = function () {
  if ( typeof console !== 'object' || ! console.log ) {
    return
  }

  return process.env.NODE_ENV !== 'production'
    ? Function.prototype.bind.call( console.log, console )
    : function () {}
}()

/**
 * Module Exports
 */
export { debug }